module.exports = __webpack_public_path__ + "static/media/wiktor.9ad13383.jpg";